<template>
  <div class="products">
    <div class="boxCenter">
      <div class="insideBanner">
        <img :src="bannerImg" alt="TINDOE坦途"/>
        <!--<div class="title">商品信息</div>-->
        <div class="searchBox">
          <input placeholder="请输入商品" v-model="key"/>
          <span class="btn" @click="loadListByClassId"></span>
        </div>
      </div>

      <div class="baseActivities">
        <div class="classBox">
          <span  class="item" :class="{'active':curClassOneId == ''}" @click="selectOneAll">全部</span>
          <span v-for="(item,index) in productClassList" :key="index" class="item" :class="{'active':curClassOneId == item.id}" @click="selectOneClass(item)">{{item.name}}</span>
        </div>
        <div class="classBox" v-if="curShowOneClass">
          <span  class="item" :class="{'active':curClassTwoId == ''}" @click="selectTwoAll">全部</span>
          <span v-for="(item,index) in curShowOneClass.categories" :key="index" class="item" :class="{'active':curClassTwoId == item.id}" @click="selectTwoClass(item)">{{item.name}}</span>
        </div>
        <div class="classBox" v-if="curShowTwoClass">
          <span  class="item" :class="{'active':curClassThreeId == ''}" @click="selectTreeAll">全部</span>
          <span v-for="(item,index) in curShowTwoClass.categories" :key="index" class="item" :class="{'active':curClassThreeId == item.id}" @click="selectTreeClass(item)">{{item.name}}</span>
        </div>
        <div class="filterBox">
          <span class="fth">商品价格：</span>
          <span class="ftd" v-for="(item,index) in priceList" :key="index"><a :class="{'active':item.selected}" @click="switchPrice(item)">{{item.name}}</a></span>
        </div>
      </div>
      <div class="baseProductList">
        <ul v-if="proList.length>0">
          <li v-for="(item,index) in proList" :key="index">
            <router-link :to="'/productDetails/'+item.id">
            <div class="bigImgBox"><img :src="item.pic" alt="TINDOE坦途"/></div>
            <div class="des">{{item.name}}</div>
            <div class="price">
              <span>会员价：¥<i>{{parseFloat(item.memberPrice || 0).toFixed(2)}}</i></span>
              <del>原价：¥<i>{{parseFloat(item.price || 0).toFixed(2)}}</i></del>
            </div>
            </router-link>
          </li>
        </ul>
        <div v-else>
          <p style="text-align: center;padding-top: 50px;">暂无相关数据...</p>
        </div>
      </div>
      <div style="padding:40px 0;text-align: center">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="curPage"
          :page-size="12"
          :total="totalNews">
        </el-pagination>
      </div>
      <div class="newProductList">
        <div class="title">商品推荐</div>
        <ul>
          <li v-for="(item,index) in recommendGoods" :key="index">
            <router-link :to="'/productDetails/'+item.id">
            <img :src="item.pic" alt="TINDOE坦途"/>
            <p class="price">
              <span>会员价：¥<i>{{parseFloat(item.memberPrice||0).toFixed(2)}}</i></span>
              <del>原价：¥<i>{{parseFloat(item.price||0).toFixed(2)}}</i></del>
            </p>
            </router-link>
          </li>
        </ul>
      </div>

    </div>
  </div> 
</template>

<script>
  export default {
    data(){
      return {
        curPage:1,
        totalNews:0,
        dataValue:'',   //时间值
        productClassList:[], //商品分类列表
        curShowOneClass:null, //当前显示的一级分类
        curShowTwoClass:null, //前端显示的二级分类
        priceList:[       //活动价格列表
          {
            startPrice:'',
            endPrice:'',
            name:'全部',
            selected:true
          },
          {
            startPrice:'0',
            endPrice:'99',
            name:'0-99',
            selected:false
          },
          {
            startPrice:'100',
            endPrice:'499',
            name:'100-499',
            selected:false
          },
          {
            startPrice:'500',
            endPrice:'999',
            name:'500-999',
            selected:false
          },
          {
            startPrice:'1000',
            endPrice:'4999',
            name:'1000-4999',
            selected:false
          },
          {
            startPrice:'5000',
            endPrice:'',
            name:'5000以上',
            selected:false
          },
        ],
        curPrice:{
          startPrice:'',
          endPrice:''
        },
        curClassOneId:'',
        curClassTwoId:'',
        curClassThreeId:'',
        curId:'',
        proList:[], //商品列表
        recommendGoods:[],//推荐商品列表
        key:'',   //关键字搜索
        bannerImg:''
      }
    },
    mounted(){
      if(this.$route.params.id){
        this.curId = this.$route.params.id
      }
      this.loadProductList()
      this.loadListByClassId()
      this.recommendTourismList()
      this.loadBanner()
    },
    methods:{

      handleCurrentChange(val){
        this.curPage = val
        this.loadListByClassId()
      },
      //获取商品分类列表
      loadProductList(){
        this.$https.get('/api/category').then((response)=>{
          this.productClassList = response.data
          this.productClassList.forEach((item) => {
            if(item.id == this.curId){
              this.curClassOneId = item.id
              if(item.categories.length > 0){
                this.curShowOneClass = item
              }
            }
          })
        }).catch((error) => {

        });
      },
      //根据商品分类获取商品列表
      loadListByClassId(){
        this.$https.get('/api/goods/pageIndex/'+this.curPage+'/pageNum/12?goodsName='+this.key+'&categoryId='+this.curId
          +'&priceMin='+this.curPrice.startPrice+'&priceMax='+this.curPrice.endPrice).then((response)=>{
          this.proList = response.data.records
          this.totalNews = response.data.total
        });
      },
      //推荐商品
      recommendTourismList(){
        this.$https.get('/api/goods/recommend/count/6').then((response)=>{
          this.recommendGoods = response.data
        });
      },
      selectOneClass(item){
        this.curId = item.id
        this.curClassOneId = item.id

        this.curClassTwoId = ''
        this.curClassThreeId = ''

        this.curShowTwoClass = null
        if(item.categories.length > 0){
          this.curShowOneClass = item
        }else{
          this.curShowOneClass = null
        }
        this.loadListByClassId()
      },
      selectOneAll(){
        this.curId = ''
        this.curClassOneId = ''

        this.curClassTwoId = ''
        this.curClassThreeId = ''

        this.curShowOneClass = null
        this.curShowTwoClass = null

        this.loadListByClassId()
      },
      selectTwoClass(item){
        this.curId = item.id
        this.curClassTwoId = item.id
        this.curClassThreeId = ''
        if(item.categories.length > 0){
          this.curShowTwoClass = item
        }else{
          this.curShowTwoClass = null
        }
        this.loadListByClassId()
      },
      selectTwoAll(){
        this.curId = this.curClassOneId
        this.curClassTwoId = ''
        this.curClassThreeId = ''
        this.curShowTwoClass = null
        this.loadListByClassId()
      },
      selectTreeClass(item){
        this.curId = item.id
        this.curClassThreeId = item.id
        this.loadListByClassId()
      },
      selectTreeAll(){
        this.curId = this.curClassTwoId
        this.curClassThreeId = ''
        this.loadListByClassId()
      },
      //价格切换
      switchPrice(item){
        this.priceList.forEach((row)=>{
          row.selected = false
        })
        item.selected = true
        this.curPrice.startPrice = item.startPrice
        this.curPrice.endPrice = item.endPrice
        this.loadListByClassId()
      },
      loadBanner(){
        this.$https.get('/api/config').then((response)=>{
          this.dataObj = response.data
          for(let i=0;i<response.data.length;i++){
            let item = response.data[i]
            if(item.id == 8){
              this.bannerImg = item.msg
              break
            }
          }
        }).catch((error) => {

        });
      }
    }
  }
</script>

<style scoped>
  .products{
    background: #fafafa;
  }
  .insideBanner{
    width: 1200px;
    height: 275px;
    position: relative;
  }
  .insideBanner .title{
    font-size: 48px;
    color: #ffffff;
    width: 100%;
    text-align: center;
    left: 0px;
    top: 80px;
    position: absolute;
  }
  .insideBanner .searchBox{
    width: 418px;
    height: 45px;
    padding-left: 62px;
    background: url("../assets/images/search-icon.png") #ffffff 13px 8px no-repeat;
    border-radius: 4px;
    position: absolute;
    top: 157px;
    left: 50%;
    margin-left: -240px;
  }
  .insideBanner .searchBox input{
    width: 100%;
    height: 45px;
    border: 0px;
    padding: 0px;
    outline: none;
    font-size: 14px;
  }
  .insideBanner .searchBox .btn{
    display: block;
    width: 39px;
    height: 39px;
    background: url("../assets/images/search-icon1.png") no-repeat;
    cursor: pointer;
    position: absolute;
    top: 3px;
    right: 3px;
    cursor: pointer;
  }
  .insideBanner img{
    width: 100%;
    height: 100%;
  }
  .baseActivities{
    margin-top: 12px;
    background: #ffffff;
  }
  .baseActivities .classBox{
    border-bottom: 1px solid #e5e5e5;
    padding: 23px 3px  5px;
    overflow: hidden;
  }
  .baseActivities .classBox .item{
    float: left;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    font-size: 15px;
    color: #363636;
    border-radius: 3px;
    margin: 0px 21px;
    cursor: pointer;
  }
  .baseActivities .classBox .item.active{
    background: #5680f9;
    color: #ffffff;
  }
  .baseActivities .filterBox{
    margin: 0 10px;
    border-bottom: 1px dashed #e5e5e5;
    height: 42px;
    padding-top: 13px;
    line-height: 42px;
  }
  .baseActivities .filterBox .fth{
    float: left;
    width: 107px;
    text-align: center;
    font-size: 13px;
    color: #919191;
    padding-right: 28px;
  }
  .baseActivities .filterBox .ftd{
    float: left;
    width: 90px;
  }
  .baseActivities .filterBox .ftd a{
    display: inline-block;
    height: 21px;
    line-height: 21px;
    padding: 0 8px;
    font-size: 13px;
    color: #363636;
    cursor: pointer;
    border-radius: 3px;
  }
  .baseActivities .filterBox .ftd a.active{
    background: #5680f9;
    color: #ffffff;
  }
  .baseProductList{
    padding-top: 12px;
  }
  .baseProductList ul{
    width: 1213px;
    overflow: hidden;
    margin-left: -13px;
  }
  .baseProductList ul li{
    width: 288px;
    float: left;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    margin: 0 0 26px 13px;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.05);
    padding-bottom:10px;
  }
  .baseProductList .bigImgBox{
    width: 288px;
    height: 288px;
  }
  .baseProductList .bigImgBox img{
    width: 100%;
    height: 100%;
  }
  .baseProductList .imgList{
    overflow: hidden;
    padding: 0 5px;
    display: none;
  }
  .baseProductList .imgList .item{
    width: 33px;
    height: 33px;
    border: 1px solid #e5e5e5;
    float: left;
    margin: 0 5px;
  }
  .baseProductList .imgList .item img{
    width: 100%;
    height: 100%;
  }
  .baseProductList .price{
    line-height: 25px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color: #ffcd30;
  }
  .baseProductList .price del{
    color:#ccc;
    font-size: 18px;
  }
  .baseProductList .price span{
    display: block;
    margin-top:10px;
    font-size: 18px;
  }
  .baseProductList .price span i{
    font-size: 32px;
  }
  .baseProductList .des{
    height: 23px;
    line-height: 23px;
    padding: 0 10px;
    margin-top:10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #363636;
  }
  .newProductList{
    margin-top:20px;
  }
  .newProductList .title{
    height: 46px;
    line-height: 46px;
    padding: 0 35px;
    background: #5680f9;
    color: #ffffff;
    font-size: 17px;
  }
  .newProductList ul{
    padding-top: 12px;
    width: 1233px;
    margin-left: -33px;
    overflow: hidden;
  }
  .newProductList ul li{
    width: 378px;
    height: 378px;
    float: left;
    margin: 0 0 33px 33px;
    background: #ffffff;
    position: relative;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.05);
  }
  .newProductList ul li img{
    width: 100%;
    height: 100%;
  }
  .newProductList .price{
    line-height: 30px;
    padding: 0 35px;
    position: absolute;
    bottom: 0px;
    left: 0px; right:0px;
    color: #ffcd30;
    background: rgba(0,0,0,0.3);
  }
  .newProductList .price del{
    font-size:18px; 
    color:#ccc;
  }
  .newProductList .price span{
    display: block;
    margin-top:10px;
    font-size: 18px;
  }
  .newProductList .price span i{
    font-size: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/products.vue